<div
  class="callout flex flex-row items-center"
  [class.callout--compact]="compact"
  data-test="calloutContent">
  <div class="callout__content flex flex-column items-start ph-4">
    <div class="flex flex-row items-center" style="flex-wrap: wrap">
      <div class="callout__title" data-test="calloutContentTitle">{{ content.title }}</div>

      <div>
        <app-tag
          *ngIf="content.tag"
          [icon]="content.tagIcon"
          [label]="content.tag"
          data-test="calloutContentTag">
        </app-tag>
      </div>
    </div>

    <div
      *ngIf="content.description"
      class="callout__description mt-5"
      data-test="calloutContentDescription">
      {{ content.description }}
    </div>

    <div class="callout__actions mt-10">
      <button
        type="button"
        class="mr-6"
        app-button
        buttonTheme="light"
        buttonType="primary"
        buttonSize="large"
        (click)="handleActionClick()"
        data-test="calloutContentAction">
        {{ content.actionText }}
      </button>

      <a
        *ngIf="content.secondaryActionText"
        class="text-link text-14 mv-4"
        (click)="handleSecondaryActionClick()"
        data-test="calloutContentSecondaryAction">
        {{ content.secondaryActionText }}
      </a>
    </div>
  </div>

  <div
    *ngIf="content.image && !compact"
    class="callout__image-container flex flex-row items-start justify-between ph-4">
    <img
      class="callout__image"
      [src]="content.image"
      [attr.alt]="content.title"
      data-test="calloutContentImage" />
  </div>
</div>
